export interface KiMarker {
  ki_erzeugt: boolean
  origin: string
}

export function showKiMarker(marker: KiMarker, value: string, confirmed: boolean): boolean {
  return marker.ki_erzeugt && value === marker.origin && !confirmed
}
